/**
 * Day Column Header — weekday + date number.
 * Today: primary colored text (no circle).
 * Weekend: slightly dimmed.
 */

import React from 'react'
import { format } from 'date-fns'
import { uz } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import { formatDateStr } from '@turnifly/shared/utils'

interface DayColumnHeaderProps {
  day: number
  year: number
  month: number
  todayDateStr: string // YYYY-MM-DD
}

export const DayColumnHeader: React.FC<DayColumnHeaderProps> = React.memo(({ day, year, month, todayDateStr }) => {
  const { i18n } = useTranslation()
  const date = new Date(year, month - 1, day)
  const isToday = formatDateStr(year, month, day) === todayDateStr

  const locale = i18n.language === 'uz' ? uz : undefined
  const weekdayStr = format(date, 'EEEEEE', { locale }).slice(0, 2)

  // Weekday name: primary for today, #768c9e for all others
  const weekdayCls = isToday ? 'text-primary' : ''
  const weekdayStyle = isToday ? undefined : { color: '#768c9e' }

  // Day number: primary for today, white for all others
  const dayCls = isToday ? 'text-primary' : 'text-text'

  return (
    <div className="h-10 flex flex-col items-center justify-center">
      <span className={`text-[9px] uppercase font-semibold leading-none ${weekdayCls}`} style={weekdayStyle}>
        {weekdayStr}
      </span>
      <span className={`text-[13px] font-display font-bold leading-none mt-0.5 ${dayCls}`}>
        {day}
      </span>
    </div>
  )
})

DayColumnHeader.displayName = 'DayColumnHeader'
